import store from '../../../store'

export default {
  orderById: 222,
  elementType: 'SelectBox',
  baseElementType: 'SELECT',
  elementDesc: '城市选择',
  type: 'selectbox',
  // 是否可配置
  config: true,
  title: '城市选择',
  placeholder: '',
  visibility: '0',
  toolbar: {
    config: false
  },
  paramInt01: '3',
  value: '',
  textValue: '',
  otherAnswer: '',
  tipsProvince: '省份',
  tipsCity: '城市',
  tipsArea: '区县',
  tipsDetailAdress: '详细地址',
  tipsProvinceCity: '省市',
  tipsProvinceCityArea: '省市区',
  tipsProvinceCityAreaDetail: '省市区详细地址',
  saveCb (data) {
    const { answerConfigVO } = data
    this.paramInt01 = answerConfigVO.paramInt01
    const surveyAnswer = store.getters.surveyAnswer
    
    if (surveyAnswer && surveyAnswer.answerListObj) {
      const answerData = surveyAnswer.answerListObj.find(item => (item.quId === data.id))

      if (answerData) {
        this.textValue = answerData.screenData
        if (answerData.answers.length) {
          const selData = answerData.answers[0]
          const arr = []
          this.otherAnswer = answerData.answers[0].otherAnswer
          if (selData.answer1) {
            arr.push(selData.answer1)
          }
          if (selData.answer2) {
            arr.push(selData.answer2)
          }
          if (selData.answer3) {
            arr.push(selData.answer3)
          }
          this.value = arr.join(',')
        }
      }
    }
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      belongAnswerId: this.belongAnswerId,
      quId: this.id,
      answserScore: this.value
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/SelectBox/config.js